import styled from "styled-components";
import { ILabel } from "./Label.types";

const StyledLabel = styled.label<ILabel>`
  display: block;
  text-align: left;
  margin-bottom: 4px;
  font-weight: 500;
  font-size: 16px;
  line-height: 120%;
  opacity: ${({ disabled, theme }) => (disabled ? theme.disabledOpacity : 1)};
`;

export default StyledLabel;
